module.exports = __webpack_public_path__ + "static/media/8_of_spades.4b6c241a.png";